// Utility Tranform data to text , array and etc.
import moment from 'moment'
export class Readable {
}
export class Compareable {
}
export class Convertable {
}
export class Value {
}
export class Storage {
}

Value.notZeroOrNull = function (value) {
  if (value && value !== 0) {
    return value
  }
}

Value.status = {
  from (constant) {
    switch (constant) {
      case 'ไม่มี': return 'none'
      case 'จอง': return 'reserved'
      case 'หาคน': return 'booking'
      case 'รอพิจารณา': return 'waiting'
      case 'แมทซ์แล้ว': return 'matched'
      case 'ทำงานอยู่': return 'working'
    }
  },
}

Value.caregiver = {
  all () {
    return ['CG', 'CGN', 'NA', 'PN', 'RN', 'DR', 'PT']
  },
}

Value.skill = {
  from (constant) {
    switch (constant) {
      case 'ดูแลถุงหน้าท้อง': return 'colostomy'
      case 'วัดสัญญาณชีพ': return 'vitalSign'
      case 'เคลื่อนย้ายคนไข้': return 'transferring'
      case 'กายภาพเบื้องต้น': return 'basicPhysicalTherapy'
      case 'สวนอุจจาระ': return 'enema'
      case 'เช็ดตัวบนเตียง': return 'bedBath'
      case 'ฟีด ทางจมูก': return 'feedingNose'
      case 'ฟีด ทางหน้าท้อง': return 'feedingStomach'
      case 'ซัคชั่น ปาก': return 'suctionOral'
      case 'ซัคชั่น เจาะคอ': return 'suctionTracheostomy'
      case 'สวนปัสสาวะทิ้ง': return 'intermittentCatheterization'
      case 'ดูแลสายสวนปัสสาวะคา (เทฉี่)': return 'retainedCatheterization'
      case 'เจาะนํ้าตาล': return 'bloodSugar'
      case 'ฉีดยาใต้ผิวหนัง': return 'injection'
      case 'ทําแผล ระดับ 1': return 'woundCareLevel1'
      case 'ทําแผล ระดับ 2': return 'woundCareLevel2'
      case 'ทําแผล ระดับ 3': return 'woundCareLevel3'
      case 'ทําแผล ระดับ 4': return 'woundCareLevel4'
    }
  },
  fromValue (constant) {
    switch (constant) {
      case 'colostomy': return 'ดูแลถุงหน้าท้อง'
      case 'vitalSign': return 'วัดสัญญาณชีพ'
      case 'transferring': return 'เคลื่อนย้ายคนไข้'
      case 'basicPhysicalTherapy': return 'กายภาพเบื้องต้น'
      case 'enema': return 'สวนอุจจาระ'
      case 'bedBath': return 'เช็ดตัวบนเตียง'
      case 'feedingNose': return 'ฟีด ทางจมูก'
      case 'feedingStomach': return 'ฟีด ทางหน้าท้อง'
      case 'suctionOral': return 'ซัคชั่น ปาก'
      case 'suctionTracheostomy': return 'ซัคชั่น เจาะคอ'
      case 'intermittentCatheterization': return 'สวนปัสสาวะทิ้ง'
      case 'retainedCatheterization': return 'ดูแลสายสวนปัสสาวะคา (เทฉี่)'
      case 'bloodSugar': return 'เจาะนํ้าตาล'
      case 'injection': return 'ฉีดยาใต้ผิวหนัง'
      case 'woundCareLevel1': return 'ทําแผล ระดับ 1'
      case 'woundCareLevel2': return 'ทําแผล ระดับ 2'
      case 'woundCareLevel3': return 'ทําแผล ระดับ 3'
      case 'woundCareLevel4': return 'ทําแผล ระดับ 4'
    }
  },
  generalAll () {
    return [
      'vitalSign',
      'transferring',
      'basicPhysicalTherapy',
      'enema',
      'bedBath',
      'feedingNose',
      'feedingStomach',
      'suctionOral',
      'suctionTracheostomy',
      'retainedCatheterization',
      'bloodSugar',
      'injection',
    ]
  },
  generalThaiAll () {
    return [
      'วัดสัญญาณชีพ',
      'เคลื่อนย้ายคนไข้',
      'กายภาพเบื้องต้น',
      'สวนอุจจาระ',
      'เช็ดตัวบนเตียง',
      'ฟีด ทางจมูก',
      'ฟีด ทางหน้าท้อง',
      'ซัคชั่น ปาก',
      'ซัคชั่น เจาะคอ',
      'ดูแลสายสวนปัสสาวะคา (เทฉี่)',
      'เจาะนํ้าตาล',
      'ฉีดยาใต้ผิวหนัง',
    ]
  },
  othersAll () {
    return [
      'intermittentCatheterization',
      'colostomy',
      'woundCareLevel1',
      'woundCareLevel2',
      'woundCareLevel3',
      'woundCareLevel4',
    ]
  },
  othersThaiAll () {
    return [
      'สวนปัสสาวะทิ้ง',
      'ดูแลถุงหน้าท้อง',
      'ทําแผล ระดับ 1',
      'ทําแผล ระดับ 2',
      'ทําแผล ระดับ 3',
      'ทําแผล ระดับ 4',
    ]
  },
  all () {
    return [
      'vitalSign',
      'transferring',
      'basicPhysicalTherapy',
      'enema',
      'bedBath',
      'feedingNose',
      'feedingStomach',
      'suctionOral',
      'suctionTracheostomy',
      'intermittentCatheterization',
      'retainedCatheterization',
      'colostomy',
      'bloodSugar',
      'injection',
      'woundCareLevel1',
      'woundCareLevel2',
      'woundCareLevel3',
      'woundCareLevel4',
    ]
  },
  thai () {
    return [
      'ดูแลถุงหน้าท้อง',
      'วัดสัญญาณชีพ',
      'เคลื่อนย้ายคนไข้',
      'กายภาพเบื้องต้น',
      'สวนอุจจาระ',
      'เช็ดตัวบนเตียง',
      'ฟีด ทางจมูก',
      'ฟีด ทางหน้าท้อง',
      'ซัคชั่น ปาก',
      'ซัคชั่น เจาะคอ',
      'สวนปัสสาวะทิ้ง',
      'ดูแลสายสวนปัสสาวะคา (เทฉี่)',
      'เจาะนํ้าตาล',
      'ฉีดยาใต้ผิวหนัง',
      'ทําแผล ระดับ 1',
      'ทําแผล ระดับ 2',
      'ทําแผล ระดับ 3',
      'ทําแผล ระดับ 4',
    ]
  },
}

Compareable.skill = function (prev, next) {
  function weight (skill) {
    switch (skill) {
      case 'vitalSign': return 1
      case 'transferring': return 2
      case 'basicPhysicalTherapy': return 3
      case 'enema': return 4
      case 'bedBath': return 5
      case 'feedingNose': return 6
      case 'feedingStomach': return 7
      case 'suctionOral': return 8
      case 'suctionTracheostomy': return 9
      case 'intermittentCatheterization': return 10
      case 'retainedCatheterization': return 11
      case 'colostomy': return 12
      case 'bloodSugar': return 13
      case 'injection': return 14
      case 'woundCareLevel1': return 15
      case 'woundCareLevel2': return 16
      case 'woundCareLevel3': return 17
    }
  }
  return weight(prev) - weight(next)
}

Compareable.skillName = function (prev, next) {
  function weight (skill) {
    switch (skill) {
      case 'vitalSign': return 1
      case 'transferring': return 2
      case 'basicPhysicalTherapy': return 3
      case 'enema': return 4
      case 'bedBath': return 5
      case 'feedingNose': return 6
      case 'feedingStomach': return 7
      case 'suctionOral': return 8
      case 'suctionTracheostomy': return 9
      case 'intermittentCatheterization': return 10
      case 'retainedCatheterization': return 11
      case 'colostomy': return 12
      case 'bloodSugar': return 13
      case 'injection': return 14
      case 'woundCareLevel1': return 15
      case 'woundCareLevel2': return 16
      case 'woundCareLevel3': return 17
      case 'woundCareLevel4': return 18
    }
  }
  return weight(prev.name) - weight(next.name)
}

Compareable.disease = function (prev, next) {
  function weight (disease) {
    switch (disease) {
      case 'hypertension' : return 1
      case 'postOperation' : return 2
      case 'stroke' : return 3
      case 'diabetes' : return 4
      case 'cancer' : return 5
      case 'parkinson' : return 6
      case 'arthrosis' : return 7
      case 'alzheimer' : return 8
      case 'kidneyFailure' : return 9
      case 'psychiatric' : return 10
      case 'other' : return 11
    }
  }
  return weight(prev.name) - weight(next.name)
}

// READ - TEXT
Readable.patient = {
  type: {
    from (constant) {
      switch (constant) {
        case 1: return '1. ผู้ป่วยช่วยเหลือตัวเองได้'
        case 2: return '2. ผู้ป่วยช่วยเหลือตัวเองได้บ้าง ต้องการคนดูแลกิจวัตรประจําวันทั่วไป'
        case 3: return '3. ผู้ป่วยติดเตียง'
      }
    },
  },
}

Readable.customer = {
  type: {
    from (constant) {
      if (constant === 'general') {
        return 'ลูกค้าทั่วไป'
      } else if (constant === 'company') {
        return 'ลูกค้าบริษัท'
      } else {
        return ''
      }
    },
  },
}

Readable.customerCompany = {
  type: {
    from (constant) {
      if (constant === 'other') {
        return 'บริษัทอื่นๆ'
      } else if (constant === 'MTL') {
        return 'บริษัท MTL'
      } else {
        return ''
      }
    },
  },
}

Readable.caregiver = {
  type: {
    from (constant) {
      switch (constant) {
        case 'CGN': return 'นักเรียนแคร์โปร แคร์โปร ผู้ดูแลมืออาชีพ'
        case 'CG': return 'แคร์โปร ผู้ดูแลมืออาชีพ'
        case 'NA': return 'พนักงานผู้ช่วยพยาบาล (NA)'
        case 'PN': return 'ผู้ช่วยพยาบาล (PN)'
        case 'RN': return 'พยาบาล (RN)'
        case 'DR': return 'แพทย์ (DR)'
        case 'PT': return 'นักกายภาพบําบัด (PT)'
      }
    },
    publicFrom (constant) {
      switch (constant) {
        case 'CGN': return 'แคร์โปร ผู้ดูแลมืออาชีพ'
        case 'CG': return 'แคร์โปร ผู้ดูแลมืออาชีพ'
        case 'NA': return 'พนักงานผู้ช่วยพยาบาล (NA)'
        case 'PN': return 'ผู้ช่วยพยาบาล (PN)'
        case 'RN': return 'พยาบาล (RN)'
        case 'DR': return 'แพทย์ (DR)'
        case 'PT': return 'นักกายภาพบําบัด (PT)'
      }
    },
  },
}

Readable.religion = {
  from (constant) {
    switch (constant) {
      case 'buddhism': return 'พุทธ'
      case 'christian': return 'คริสต์'
      case 'islamic': return 'อิสลาม'
      default: return constant
    }
  },
}

Readable.bank = {
  from (constant) {
    switch (constant) {
      case 'kbank': return 'กสิกร KBANK'
      case 'scb': return 'ไทยพาณิชย์ SCB'
      case 'bbl': return 'กรุงเทพ BBL'
      case 'ktb': return 'กรุงไทย KTB'
      case 'bay': return 'กรุงศรี BAY'
      case 'tmb': return 'ทหารไทย TMB'
      case 'gsb': return 'ออมสิน GSB'
      case 'other': return 'ธนาคารอื่น'
      default: return constant
    }
  },
}

Readable.certification = {
  from (constant) {
    switch (constant) {
      case 'PN': return 'ประกาศนียบัตร ผู้ช่วยพยาบาล (PN)'
      case 'NA': return 'ประกาศนียบัตร พนักงานผู้ช่วยพยาบาล (NA)'
      default: return 'ไม่มี'
    }
  },
}

Readable.gender = {
  from (gender) {
    if (gender === 'male') {
      return 'ชาย'
    } else if (gender === 'female') {
      return 'หญิง'
    } else {
      return ''
    }
  },
}

Readable.relation = {
  from (constant) {
    switch (constant) {
      case 'offspring': return 'บุตร'
      case 'sibling': return 'พี่/น้อง'
      case 'spouse': return 'คู่สมรส/แฟน'
      case 'parents': return 'พ่อ/แม่'
      case 'relatives': return 'ญาติ'
      case 'outsider': return 'ไม่ใช่คนในครอบครัว'
      case 'self': return 'ตัวคนไข้เอง'
    }
    return ''
  },
}

Readable.maritalStatus = {
  from (constant) {
    switch (constant) {
      case 'single': return 'ยังไม่แต่งงาน'
      case 'married': return 'แต่งงานแล้ว'
      case 'divorced': return 'หย่าร้าง'
    }
    return ''
  },
}

Readable.skill = {
  from (constant) {
    switch (constant) {
      case 'colostomy': return 'ดูแลถุงหน้าท้อง'
      case 'vitalSign': return 'วัดสัญญาณชีพ'
      case 'transferring': return 'เคลื่อนย้ายคนไข้'
      case 'basicPhysicalTherapy': return 'กายภาพเบื้องต้น'
      case 'enema': return 'สวนอุจจาระ'
      case 'bedBath': return 'เช็ดตัวบนเตียง'
      case 'feedingNose': return 'ฟีด ทางจมูก'
      case 'feedingStomach': return 'ฟีด ทางหน้าท้อง'
      case 'suctionOral': return 'ซัคชัน ปาก'
      case 'suctionTracheostomy': return 'ซัคชัน เจาะคอ'
      case 'intermittentCatheterization': return 'สวนปัสสาวะทิ้ง'
      case 'retainedCatheterization': return 'ดูแลสายสวนปัสสาวะคา (เทฉี่)'
      case 'bloodSugar': return 'เจาะนํ้าตาล'
      case 'injection': return 'ฉีดยาใต้ผิวหนัง'
      case 'woundCareLevel1': return `ทำแผล ระดับ 1`
      case 'woundCareLevel2': return `ทำแผล ระดับ 2`
      case 'woundCareLevel3': return `ทำแผล ระดับ 3`
      case 'woundCareLevel4': return `ทำแผล ระดับ 4`
    }
  },
}

Readable.disease = {
  from (constant) {
    switch (constant) {
      case 'hypertension': return 'ความดันโลหิตสูง'
      case 'postOperation': return 'หลังผ่าตัด'
      case 'stroke': return 'อัมพฤกษ์ / อัมพาต'
      case 'diabetes': return 'เบาหวาน'
      case 'parkinson': return 'พาร์กินสัน'
      case 'kidneyFailure': return 'โรคไต'
      case 'psychiatric': return 'จิตเวช'
      case 'paralyzed': return 'อัมพาต'
      case 'cancer': return 'มะเร็ง'
      case 'alzheimer': return 'สมองเสื่อม'
      case 'arthrosis': return 'ข้อเข่าเสื่อม'
      case 'other': return 'อื่นๆ'
    }
  },
}

Readable.subDisease = {
  fromKidneyFailure (constant) {
    switch (constant) {
      case 'hospitalDialysis': return 'ฟอกไตที่โรงพยาบาล'
      case 'homeDialysis': return 'ฟอกไตที่บ้าน'
    }
  },
  fromAlzheimer (constant) {
    switch (constant) {
      case 'forgetful': return 'กลืนอาหารลำบากหรือควบคุมการขับถ่ายไม่ได้'
      case 'abusive': return 'อารมณ์ไม่คงที่ / ชอบคิดจินตนาการเอง'
      case 'sleepProblem': return 'นอนไม่เป็นเวลา หรือ มีปัญหาเรื่องการนอนหลับ'
    }
  },
  fromPsychiatric (constant) {
    switch (constant) {
      case 'abusive': return 'เมื่อไม่พอใจ อาจมีอาการฉุนเฉียวและก้าวร้าว'
      case 'sleepProblem': return 'นอนไม่หลับหรือนอนมากเกินไป'
    }
  },
}

// CONVERT
Convertable.date = {
  from (dateString) {
    return {
      toAge () {
        if (dateString && dateString !== '0001-01-01') {
          return moment().diff(dateString, 'years', false)
        } else {
          return null
        }
      },
    }
  },
}

Storage.list = {
  from (key) {
    const items = sessionStorage.getItem(key)
    if (items && items.length > 0) {
      return sessionStorage.getItem(key).split(',')
    }
    return []
  },
  fromJson (key) {
    try {
      const items = localStorage.getItem(key)
      if (items && items.length > 0) {
        return JSON.parse(localStorage.getItem(key))
      }
      return {}
    } catch (error) {
      return {}
    }
  },
}
